export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12141.02f16d18.jpg";